import { faMessageText } from '@fortawesome/pro-regular-svg-icons'
import { TextItem, TextItemInput } from 'types/graphql'

import { ItemDescription } from '..'

import Builder from './Builder'
import Element from './Element'

export const itemDescription: ItemDescription<TextItem, TextItemInput> = {
  hasCustomFields: true,
  type: 'text',
  icon: faMessageText,
  label: 'Text Section',
  generateEmptyItemDetails() {
    return {
      heading: '',
      description: '',
    }
  },
  convertToGQLInput({ id, heading, description }: TextItem): TextItemInput {
    return { id, heading, description }
  },
  Builder,
  Element,
}
